
import { useState } from 'react';
import { AdminState, AdminAction } from '@/types/adminTypes';

/**
 * Hook to manage the state for admin activity
 */
export const useAdminActivityState = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isActionThrottled, setIsActionThrottled] = useState(false);
  
  return {
    isLoading,
    setIsLoading,
    isActionThrottled,
    setIsActionThrottled
  };
};
